//------------------------------------
//Swiper slider configuration
//------------------------------------
var swiper = new Swiper(".gallery-thumbs", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  allowTouchMove: false,
});
var swiper2 = new Swiper(".gallery-slider", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

//------------------------------------
// Scroll to section
//------------------------------------
document.getElementById("scrollBtn").addEventListener("click", function () {
  document.getElementById("review_api_slider").scrollIntoView({
    behavior: "smooth" // Smooth scroll
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // -------------------------------
  // Variant Selection Logic
  // -------------------------------
  function setupVariantLogic(container) {
    const cards = container.querySelectorAll('[data-variant-card]');
    function resetAll() {
      cards.forEach(card => {
        const radio = card.querySelector('.variant-radio');
        const below = card.querySelector('.variant-below');
        if (radio) radio.checked = false;
        if (below) below.style.display = 'none';
        card.classList.remove('active');
      });
    }

    cards.forEach((card, index) => {
      // Entire card click
      card.addEventListener('click', function (e) {
        // Skip if directly clicking the radio (let it fire normally)
        if (e.target.tagName === 'INPUT' && e.target.classList.contains('variant-radio')) return;
        resetAll();


        const radio = card.querySelector('.variant-radio');
        const below = card.querySelector('.variant-below');
        if (radio && below) {
          radio.checked = true;
          below.style.display = 'block';
          card.classList.add('active');
          selectedProductSep();
        }
      });

      const radio = card.querySelector('.variant-radio');
      if (radio) {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            resetAll();
            const below = card.querySelector('.variant-below');
            if (below) below.style.display = 'block';
            card.classList.add('active');
          }
        });
      }

      // Auto-open first variant
      if (index === 0) {
        const radio = card.querySelector('.variant-radio');
        const below = card.querySelector('.variant-below');
        if (radio && below) {
          radio.checked = true;
          below.style.display = 'block';
          card.classList.add('active');   //# 1. code line commented
        }
      }
    });
    // tab buttons click to remove class active from the other varians and first variant active 
    let tabButton = document.querySelector('.refill-tab-button');
    if (tabButton) {
      tabButton.addEventListener("click", function() {
        resetAll();
        const variantListFirstChild = document.querySelector('.variant-list')?.firstElementChild;
        const below = variantListFirstChild?.querySelector('.variant-below');
        if (below) below.style.display = 'block';
        if (variantListFirstChild) {
          variantListFirstChild.classList.add("active"); // #2
        }
      });
    }
  }

  // -------------------------------
  // Tab Switching Logic
  // -------------------------------
  const tabButtons = document.querySelectorAll('.refill-tab-button');
  const tabPanels = document.querySelectorAll('.refill-panel');
  const ratingTarget = document.getElementById('rating-target');
  tabButtons.forEach(button => {
    button.addEventListener('click', function () {
      const index = this.getAttribute('data-option-index');

      // Remove active class from all buttons
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      // Hide all panels
      tabPanels.forEach(panel => {
        panel.style.display = 'none';
        panel.classList.remove('active');
        const variantListChild = panel.querySelector('.variant-card');
        variantListChild.classList.remove("active");
      });

      // Show selected panel
      const targetPanel = document.querySelector(`.refill-panel[data-detail-index="${index}"]`);
      if (targetPanel) {
        targetPanel.style.display = 'block';
        targetPanel.classList.add('active');
        setupVariantLogic(targetPanel);
        selectedProductSep();
      }

      // Update rating section
      const activePanel = Array.from(tabPanels).find(panel =>
        panel.classList.contains('active')
      );
      if (activePanel) {
        const ratingSection = activePanel.querySelector('.yotpo-widget-instance');
        if (ratingSection) {
          const clonedRating = ratingSection.cloneNode(true); // clone instead of move
          ratingTarget.innerHTML = ''; // Clear old rating
          ratingTarget.appendChild(clonedRating); // Append cloned rating
        }
      }
    });
  });

  // -------------------------------
  // Initial setup on page load
  // -------------------------------
  const firstPanel = document.querySelector('.refill-panel[data-detail-index="0"]');
  if (firstPanel) {
    setupVariantLogic(firstPanel);
    selectedProductSep();
  }

  // -------------------------------
  // Accordion Toggle Logic
  // -------------------------------
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const icon = header.querySelector('.accordion-icon');
      const isOpen = content.style.display === 'block';

      content.style.display = isOpen ? 'none' : 'block';
      icon.textContent = isOpen ? '+' : '−';
    });
  });

  // ---------------------------
  // Active tab product details
  //----------------------------
  const activeButton = document.querySelector('.refill-tab-button.active');
  if (activeButton) {
    const productID = activeButton.getAttribute('data-option-product-id');
    fetch(`/products.json`)
      .then(response => response.json())
      .then(data => {
        const product = data.products.find(p => p.id == productID);
      });
  }

  //----------------------------
  // Toggle dropdown visibility
  //----------------------------
  document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const hiddenInput = dropdown.querySelector('input[name="frequency_option"]');
    const selectedOption = dropdown.querySelector('.selected-option');
    const firstChild = dropdown.querySelector('.dropdown-item');

    if(firstChild) {
      const value = firstChild.getAttribute('data-value');
      const dataPlan = firstChild.getAttribute('data-plan');
      const text = firstChild.textContent.trim();
      selectedOption.textContent = text;
      hiddenInput.value = value;
      hiddenInput.dataset.namePlan = dataPlan;
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isExpanded));
    });

    dropdown.addEventListener('click', function (e) {
      const item = e.target.closest('.dropdown-item');
      if (item) {
        e.stopPropagation();
        const value = item.getAttribute('data-value');
        const text = item.textContent.trim();
        selectedOption.textContent = text;
        hiddenInput.value = value;

        selectedOption.textContent = text;
        // hiddenInput.value = value;
        toggle.setAttribute('aria-expanded', 'false');
        selectedProductSep();
      }
    });
  });

  // Close all dropdowns on outside click
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.dropdown-toggle[aria-expanded="true"]').forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
});

//------------------------------------------
// update Yotpo rating in different fields
//------------------------------------------

function waitForYotpoInActivePanel(callback) {
  const tabPanels = document.querySelectorAll('.refill-panel');
  const ratingTarget = document.getElementById('rating-target');

  const activePanel = Array.from(tabPanels).find(panel =>
    panel.classList.contains('active')
  );

  if (!activePanel) return;

  const checkInterval = setInterval(() => {
    const ratingSection = activePanel.querySelector('.yotpo-widget-instance');
    if (ratingSection) {
      // Clone or move rating widget
      const cloned = ratingSection.cloneNode(true);
      ratingTarget.innerHTML = '';
      ratingTarget.appendChild(cloned);

      // Optionally re-init
      if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
        window.yotpo.initWidgets();
      }

      clearInterval(checkInterval);
      if (typeof callback === 'function') callback();
    }
  }, 100); // check every 100ms
}

//-------------
// update Name
//-------------
function selectedProductSep(){
  const listItems = document.querySelectorAll('.variant-card');
  listItems.forEach ( card => {
   if (card.classList.contains('active')) {
      const prodName = card.querySelector('.variant-top .variant-info .variant-title .title');
      if (prodName) {
        const targetProductname = document.getElementById('product-name-target-outer');
        const productNameTitle = prodName.textContent.trim();
        if (targetProductname && productNameTitle) {
          targetProductname.innerHTML = productNameTitle;
        }
      }
      const frequencySelected = card.querySelector('.variant-below .custom-dropdown .dropdown-toggle .selected-option');
      if (frequencySelected){
        const frequencyTarget = document.getElementById('frequency-target-outer');
        const frequencyPlanName = frequencySelected.textContent.trim()
        if(frequencyTarget && frequencyPlanName) {
          frequencyTarget.innerHTML =  frequencyPlanName;
        }
      }
    }
  });
}
//-------------
// update price
//-------------
const tabButtons1 = document.querySelectorAll('.refill-tab-button');
const priceTarget1 = document.getElementById('product-price-target');
const priceTarget2 = document.getElementById('product-price-target-outer');

// Function to update price from the active button
function updatePriceFromActiveButton() {
  const activeButton = document.querySelector('.refill-tab-button.active');
  if (activeButton) {
    const subscriptionPrice = activeButton.getAttribute('data-option-product');
    const productPrice = activeButton.getAttribute('data-option-product-single');
    if (priceTarget1 && productPrice) {
      priceTarget1.innerHTML = '<div class="price-section"> <span class="subscribe-price">'+subscriptionPrice+'</span><span class="product-price">'+productPrice+'</span></div>';
    }
    if (priceTarget2 && productPrice) {
      priceTarget2.innerHTML = '<div class="price-section"> <span class="subscribe-price">'+subscriptionPrice+'</span></div>';
    }
  }
}
//-----------------------------
// Discount shows in precentage
//-----------------------------
function updatePrecentageFromActiveButton() {
  const activeButton = document.querySelector('.refill-tab-button.active');
  if (activeButton) {
    const subsPrice =  activeButton.getAttribute('data-option-product-subs-price');
    const subscriptionPrice = activeButton.getAttribute('data-option-product-subscription-price');
    const productPrice = activeButton.getAttribute('data-option-product-price');
    const precentageDiscount = (((productPrice - subscriptionPrice)/productPrice)*100).toFixed(0)+'%';
    const amountDiscount = activeButton.getAttribute('data-option-total-discount');

    document.querySelectorAll('.slider-bottom-text').forEach(el => {
      if (el.textContent.includes('[percentage_off]')) {
        el.textContent = el.textContent.replace('[percentage_off]', precentageDiscount);
      }
    });
    document.querySelectorAll('.details-link .metafield-rich_text_field ul li').forEach(el => {
      if (el.textContent.includes('[percentage_off]')) {
        el.textContent = el.textContent.replace('[percentage_off]', precentageDiscount);
      }
    });
    document.querySelectorAll('.variant-card .variant-below .promo-bullets ul li').forEach(el => {
      if (el.textContent.includes('[amount_off]')) {
        el.textContent = el.textContent.replace('[amount_off]', amountDiscount);
      }
    });
    document.querySelectorAll('.refill-tab-panels .details-link span').forEach(el => {
      if (el.textContent.includes('[subscription_price]')) {
        el.textContent = el.textContent.replace('[subscription_price]', subsPrice);
      }
    });
  }
}

// On tab click, update active class and price
tabButtons1.forEach(button => {
  button.addEventListener('click', function () {
    // Remove active from all, then set current as active
    tabButtons1.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
    updatePriceFromActiveButton();
    selectedProductSep();
  });
});

//-------------------------------------------------------------
// Frequency Selector to add product and checkout functionality
//-------------------------------------------------------------

window.findSellingPlanAndTitle = (productList, variantId, isSubscription) => {
  const selectedSubscriptionPlan = document.querySelector(".variant-card.active input[name='frequency_option']");
  const selectedSubscriptionPlanName = document.querySelector(".variant-card.active input").dataset.namePlan;
  const selectedSubscriptionPlanValue = selectedSubscriptionPlan.value;
  const frequencyParam = selectedSubscriptionPlanValue;
  let sellingPlan = null;
  let sellingPlanName = null;
  let relatedSubscriptionTitle = null;

  for (const product of productList) {
    for (const variant of product.variants) {
      if (variant.id === parseInt(variantId, 10)) {
        if (isSubscription) {
          sellingPlan = variant.selling_plans.find(plan => {
            const sellingPlanNameHandleized = handleize(plan.name);
            // const frequencyParamLower = handleize(frequencyParam);
            const frequencyParamLower = handleize(selectedSubscriptionPlanName);
            return frequencyParamLower === sellingPlanNameHandleized;
          });

          if (sellingPlan) {
            sellingPlanName = sellingPlan.name;
          }

          if (product.related_subscription_product) {
            relatedSubscriptionTitle = product.related_subscription_product.title;
          }

          return { sellingPlan, sellingPlanName, relatedSubscriptionTitle }; // Return early when found
        }
      }
    }
  }
  return { sellingPlan, sellingPlanName, relatedSubscriptionTitle };
};

//--------------------------------------------------
// Go to checkout button funtionality to add product
//--------------------------------------------------
document.querySelector('.btn-checkout button')?.addEventListener('click', function (e) {
  e.preventDefault();
  // 1. Find the selected variant
  const selectedCard = document.querySelector('.variant-card.active');
  if (!selectedCard) {
    console.warn('Please select a variant.');
    return;
  }
  const variantId = selectedCard.getAttribute('data-variant-id');

  // 2. Get frequency name selected
  const frequencyInput = selectedCard.querySelector('input[name="frequency_option"]');
  const frequencyValue = frequencyInput?.value;
  if (!frequencyValue) {
    console.warn('Please select a delivery frequency.');
    return;
  }

  // 3. Match selected frequency with selling plan ID
  const frequencySellingPlanMap = window.frequencySellingPlans || []; // must be set globally via Liquid
  const sellingPlanId = frequencySellingPlanMap.includes(frequencyValue);
  if (!sellingPlanId) {
    console.warn('Selling plan not found for selected frequency.');
    return;
  }

  // 4. Send to cart
  const starterKitJson = JSON.parse(document.querySelector('[data-context="starter-kit-json"]').textContent);
  const sellingPlanDetails  = findSellingPlanAndTitle(starterKitJson.product_options, variantId, true);
  const properties = {};

  if (sellingPlanDetails.relatedSubscriptionTitle) {
    properties._related_subscription_product_title = sellingPlanDetails.relatedSubscriptionTitle;
  }
  if (sellingPlanDetails.sellingPlanName) {
    properties._related_subscription_product_selling_plan_name = sellingPlanDetails.sellingPlanName;
  }

  const payload = {
    "items": [
        {
          "id": parseInt(variantId),
          "quantity": 1,
          "selling_plan": sellingPlanDetails.sellingPlan.id,
          "properties": properties
        }
      ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(data => {
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.error('Add to cart error:', err);
    });
});


//---------------------
//call funtions on load
//---------------------
window.addEventListener('load', function () {
  waitForYotpoInActivePanel();
  updatePriceFromActiveButton();
  updatePrecentageFromActiveButton();
  selectedProductSep();
});
